import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';
import logo from './../../../assets/images/certification/certification.png';
import SectionTitle from '../../SectionTitle/SectionTitle';
const Container = styled(Box)(({ theme }) => ({
    padding: theme.spacing(7),
}));

const TextSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: "center"
}));

const ImageSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',  // Center the image horizontally
    alignItems: "center",

    marginTop: theme.spacing(2),  // Add some space between the text and image
}));

const StyledImage = styled('img')({
    width: "100%",
    height: "auto",


});

const Certification = ({ t }) => {
    return (
        <Box data-aos="fade-up" sx={{ padding: "40px 0 0 0" }}>
            <Grid container direction="column" alignItems="center">
                <Grid item xs={12} data-aos="fade-down">
                    <TextSection>
                        <SectionTitle
                            title={t.certificationTitle}
                            sx={{
                                fontWeight: '700',
                                color: "#12538B",
                                fontSize: { xs: "24px", md: "32px" },
                            }}
                            dataAos="fade-down"
                        />


                        <Typography
                            sx={{
                                fontWeight: '400',
                                color: "#676464",
                                fontSize: { xs: "12px", md: "18px" },
                            }}
                        >
                           {t.certificationSubtitle}
                        </Typography>
                    </TextSection>

                </Grid>
                <Grid item xs={12}>
                    <ImageSection>
                        <StyledImage src={logo} alt="Ministry of Health"  loading="lazy"/>
                    </ImageSection>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Certification;
